// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Tid1","bigColWidth":"Table_bigColWidth__2bNlP","biggerColWidth":"Table_biggerColWidth__3Y-hG","row":"Table_row__1_iU7","col":"Table_col__1MDtx"};